export const METRIC_KEY = 'metricKey';
export const DISPLAY_MODE = 'displayMode';
export const FILTER_SET_ID = 'filterSet';
export const GAME_ID = 'gameId';
export const FILTERS_TAB = 'filtersTab';
export const PLAYER_ID = 'playerId';
export const TEAM_ID = 'teamId';
export const RADAR_TEMPLATE = 'radarTemplate';
export const RADAR_DATA_FORMAT = 'radarDataFormat';
export const DATA_LOCKER_LANDING_PAGE_TAB = 'dlLandingTab';
export const COMPARISON_ID = 'comparisonId';
export const COMPARISON_TYPE = 'comparisonType';
export const ACTIVE_TAB = 'activeTab';
export const PLAYER_PREVIEW_TAB = 'playerPreviewTab';
export const VISUALISATION = 'vis';
export const PITCH_PREVIEW_TAB = 'pitchPreviewTab';
export const SETTINGS_PANEL = 'settingsPanel';

/* shortlists bits */
export const SHORTLISTS_OWNERSHIP_FILTER = 'shortlistsOwnership';
